// SDK values remain in their documented units. Missing browser metrics are
// null, never invented zeroes; no track IDs, names, URLs or audio are retained.
export const AUDIO_QUALITY_INTERVAL_MS = 15_000;
export const AUDIO_QUALITY_MAX_REPORTS = 512;
export const LOCAL_AUDIO_METRICS = Object.freeze({
  currentPacketLossRate: 100, sendBitrate: 10_000_000,
  sendJitterMs: 120_000, sendRttMs: 120_000,
  sendPackets: 1_000_000_000, sendPacketsLost: 1_000_000_000
});
export const REMOTE_AUDIO_METRICS = Object.freeze({
  currentPacketLossRate: 100, packetLossRate: 100, freezeRate: 100,
  receiveBitrate: 10_000_000, end2EndDelay: 120_000, transportDelay: 120_000,
  receivePackets: 1_000_000_000, receivePacketsLost: 1_000_000_000,
  receivePacketsDiscarded: 1_000_000_000, totalFreezeTime: 86_400
});
const object = value => value !== null && typeof value === "object" && !Array.isArray(value);
const keysMatch = (value, keys) => object(value) && Object.keys(value).length === keys.length &&
  Object.keys(value).every(key => keys.includes(key));
const number = (value, maximum) => typeof value === "number" && Number.isFinite(value) && value >= 0 && value <= maximum;
const booleanOrNull = value => value === null || typeof value === "boolean";
export function audioMetricSnapshot(value, fields) {
  if (!object(value)) return null;
  return Object.fromEntries(Object.entries(fields).map(([key, maximum]) => [key,
    number(value[key], maximum) ? Math.round(value[key] * 1000) / 1000 : null]));
}
function validMetrics(value, fields) {
  return value === null || (keysMatch(value, Object.keys(fields)) &&
    Object.entries(fields).every(([key, maximum]) => value[key] === null || number(value[key], maximum)));
}
export function validateAudioQualityReport(value) {
  if (!keysMatch(value, ["version", "platform", "elapsedSeconds", "visibility", "micEnabled", "audioContext", "autoplayBlocked", "local", "remote"]) ||
      value.version !== 1 || !["ios_webview", "android_webview", "other"].includes(value.platform) ||
      !number(value.elapsedSeconds, 86_400) || !["visible", "hidden"].includes(value.visibility) ||
      typeof value.micEnabled !== "boolean" || typeof value.autoplayBlocked !== "boolean" ||
      !["running", "suspended", "interrupted", "closed", "unknown"].includes(value.audioContext) ||
      !validMetrics(value.local, LOCAL_AUDIO_METRICS) || !Array.isArray(value.remote) || value.remote.length > 2 ||
      !value.remote.every(track => keysMatch(track, ["playing", "metrics"]) && booleanOrNull(track.playing) && validMetrics(track.metrics, REMOTE_AUDIO_METRICS))) return null;
  return value;
}
